import { Collapse, Table, TableBody, TableCell } from "@mui/material";
import _ from "lodash";
import { useContext } from "react";
import TableNotFound from "src/pages/Admin/Demos/DemoTable/TableNotFound";
import { useGetDemoDetailRequest } from "src/services/admin/queries/demos";

import Context from "../context";
import CollapseRow from "./CollapseRow";

type Props = {
	id: string;
};
export default function CollapseTable({ id }: Props) {
	const { state } = useContext(Context);

	const { data } = useGetDemoDetailRequest(id, state.isColapsed);

	const empty = data?.length === 0;

	return (
		<TableCell colSpan={3} style={{ padding: 0 }}>
			<Collapse in={state.isColapsed} timeout='auto' unmountOnExit>
				<Table size={"small"}>
					{data && (
						<TableBody>
							{data.map((row, index) => (
								<CollapseRow {...row} key={index} />
							))}
						</TableBody>
					)}
					{empty && <TableNotFound />}
				</Table>
			</Collapse>
		</TableCell>
	);
}
